import classNames from "classnames";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";

import { useHeaderBorderStyles } from "./useHeaderColors";

export interface HeaderWrapperV3Props {
  children: ReactNode;
  className?: string;
  isRenderedOutsideSpace?: boolean;
}

export const HeaderWrapperV3 = ({
  children,
  className,
  isRenderedOutsideSpace = false,
}: HeaderWrapperV3Props) => {
  const styles = useHeaderBorderStyles();
  return (
    <nav
      data-testid="navigation-bar-wrapper"
      aria-label={t("main_navigation_bar")}
      className={classNames(
        "border-primary bg-c-header grid-cols-header sticky top-0 z-50 grid min-h-[64px] border-b",
        {
          "max-h-16 px-9 py-2": !isRenderedOutsideSpace,
          "sticky top-0 z-50 max-h-16 px-6 py-4": isRenderedOutsideSpace,
        },
        className,
      )}
      id="root-header-v2_1"
      style={styles}
    >
      {children}
    </nav>
  );
};
